module.exports = __webpack_public_path__ + "img/brake-warning.ebfde5de.svg";